import { useState } from "react";
import { Loader2, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export const AddStationDialog = ({ open, onOpenChange, onAdded }) => {
  const [form, setForm] = useState({ name: "", stream_url: "", homepage: "", tags: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/radio/stations", { ...form, tags: form.tags.split(",").map((t) => t.trim()).filter(Boolean) });
      toast.success(`${data.name} added`);
      setForm({ name: "", stream_url: "", homepage: "", tags: "" });
      onAdded(data);
      onOpenChange(false);
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="add-station-dialog">
        <DialogHeader><DialogTitle className="font-heading text-2xl">Add a stream link</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Input placeholder="Station name" value={form.name} onChange={set("name")} required data-testid="add-station-name" />
          <div>
            <Input placeholder="https://… stream, .pls or .m3u link" value={form.stream_url} onChange={set("stream_url")} required data-testid="add-station-url" />
            <p className="mt-1.5 flex items-center gap-1 text-[11px] text-zinc-500"><Link2 size={11} />MP3 / AAC / OGG streams and .pls / .m3u playlist links work. HLS isn't supported.</p>
          </div>
          <Input placeholder="Website (optional)" value={form.homepage} onChange={set("homepage")} data-testid="add-station-homepage" />
          <Input placeholder="Tags, comma separated (optional)" value={form.tags} onChange={set("tags")} data-testid="add-station-tags" />
          <DialogFooter>
            <button type="submit" disabled={busy} data-testid="add-station-submit" className="flex items-center gap-2 rounded-full bg-zinc-900 px-5 py-2 text-sm text-white disabled:opacity-50">
              {busy && <Loader2 size={14} className="animate-spin" />}{busy ? "Checking stream…" : "Add station"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
